/**
 * Extracts the video ID from a YouTube URL.
 * Supports url formats:
 * - https://www.youtube.com/watch?v=[video-id]
 * - https://www.youtu.be/[video-id]
 * - https://www.youtube-nocookie.com/embed/[video-id]
 * @param {string} url - The YouTube URL.
 * @throws {Error} If the URL is invalid.
 * @returns {string|null} The video ID or null if not found.
 */
export function extractYoutubeId(url) {
    let parsedUrl;
    if (!url)
        return null;
    try {
        parsedUrl = new URL(url);
    }
    catch (e) {
        const error = e;
        throw new Error(`${error.message}: ${url}`);
    }
    const hostnameWithoutSubdomain = parsedUrl.hostname
        .split(".")
        .slice(-2)
        .join(".");
    switch (hostnameWithoutSubdomain) {
        case "youtube.com":
            if (parsedUrl.pathname === "/watch") {
                // take the video id from the query string
                return parsedUrl.searchParams.get("v");
            }
            throw new Error(`Unsupported url: ${url}`);
        case "youtu.be":
            // take pathname excluding leading '/' as video id
            return parsedUrl.pathname.slice(1);
        case "youtube-nocookie.com":
            if (parsedUrl.pathname.startsWith("/embed/")) {
                // take last segment of pathname as video ID
                return parsedUrl.pathname.split("/").pop() || null;
            }
            throw new Error(`Unsupported url: ${url}`);
        default:
            throw new Error(`Unsupported hostname: ${parsedUrl.hostname}`);
    }
}
